import { HomePage } from "./../home/home";
import { PlazaStatSubPage } from "./../plaza-stat-sub/plaza-stat-sub";
import { GoogleChartInterface } from "ng2-google-charts/google-charts-interfaces";
import { TranslateService } from "@ngx-translate/core";
import { Http, RequestOptions, Headers } from "@angular/http";
import { ServiceProvider } from "./../../providers/service/service";
import { Storage } from "@ionic/storage";
import { ViewHeaderPage } from "./../view-header/view-header";
import { Component } from "@angular/core";
import {
  IonicPage,
  NavController,
  LoadingController,
  NavParams,
} from "ionic-angular";

@IonicPage()
@Component({
  selector: "page-plaza-stat-shopper",
  templateUrl: "plaza-stat-shopper.html",
})
export class PlazaStatShopperPage {
  data = { total: "" };
  shoppers = [{ shopper_id: "", shopper_name: "", total: "", total_sales: "" }];
  shoppers_total = 0;
  // public pieChart: GoogleChartInterface = {
  //   chartType: "PieChart",
  //   dataTable: [
  //     ["CELEB", 0],
  //     ["OFFICE", 0],
  //     ["FAMILY", 0],
  //     ["FOREIGNER", 0],
  //     ["ELDER", 0],
  //     ["TEENAGE", 0],
  //   ],
  //   opt_firstRowIsData: true,
  //   options: {
  //     title: "",
  //     pieSliceText: "value",
  //     legend: {
  //       position: "none",
  //       //  textStyle: {color: '#d59237', fontSize: 10},
  //       //  alignment: 'center',
  //       //  maxLines: 2
  //     },
  //     is3D: false,
  //     chartArea: {
  //       left: 0,
  //       top: 5,
  //       bottom: 5,
  //       width: "100%",
  //       height: "100%",
  //       strokeWidth: 1,
  //       stroke: "#d59237",
  //     },
  //     // width: '100%',
  //     backgroundColor: { fill: "transparent" },
  //     colors: [
  //       "#efa646",
  //       "#3d8a43",
  //       "#3d4c9f",
  //       "#aa4f9e",
  //       "#EE5435",
  //       "#FF69B4",
  //     ],
  //     animation: {
  //       duration: 3000,
  //     },
  //   },
  // };

  public pieChart2: GoogleChartInterface = {
    chartType: "PieChart",
    dataTable: this.navParams.data.stat_shopperAmount,
    opt_firstRowIsData: true,
    options: {
      title: "",
      pieSliceText: "value",
      legend: {
        position: "none",
        // textStyle: {color: '#d59237', fontSize: 10},
        // alignment: 'center',
        // maxLines: 2
      },
      is3D: false,
      chartArea: {
        left: 0,
        top: 5,
        bottom: 5,
        width: "100%",
        height: "100%",
        strokeWidth: 1,
        stroke: "#d59237",
      },
      // width: '100%',
      backgroundColor: { fill: "transparent" },
      colors: [
        "#efa646",
        "#3d8a43",
        "#3d4c9f",
        "#aa4f9e",
        "#EE5435",
        "#FF69B4",
      ],
      animation: {
        duration: 3000,
      },
    },
  };

  // shopperBath: any;
  shopperAmount: any;
  theme = 1;
  constructor(
    public navCtrl: NavController,
    private storage: Storage,
    private services: ServiceProvider,
    private http: Http,
    public translateService: TranslateService,
    private loadingCtrl: LoadingController,
    public navParams: NavParams
  ) {
    // this.shopperBath = this.navParams.data.stat_shopperBath;
    this.shopperAmount = this.navParams.data.stat_shopperAmount;
    this.shoppers = this.navParams.data.shoppers.filter((x) => x.total != 0);
    this.shoppers_total = this.navParams.data.shoppers_total;
  }

  async ionViewDidLoad() {
    this.theme = await this.storage.get("theme");

    const loader = this.loadingCtrl.create({
      content: "Loading...",
    });
    loader.present();

    // this.pieChart.dataTable = this.shopperBath;
    // console.log("dataTable===>", this.pieChart2.dataTable);
    // if (!this.pieChart2.dataTable.MF) {
    // console.log("shopperAmount===>", this.shopperAmount);
    // console.log("shoppers===>", this.shoppers);
    // console.log("shoppers_total===>", this.shoppers_total);

    this.pieChart2.dataTable = this.shopperAmount;
    // }

    // this.storage.get("token").then((token) => {
    //   var link = this.services.URLPlazaStatShopper;
    //   var headers = new Headers();
    //   headers.append("Accept", "application/json");
    //   headers.append("Authorization", "Bearer " + token);
    //   const requestOptions = new RequestOptions({ headers: headers });

    //   this.http
    //     .get(link, requestOptions)
    //     .map((res) => res.json())
    //     .subscribe(
    //       (data) => {
    //         this.data = data;
    //         this.shoppers = data.shoppers;
    //         console.log("data===>", this.data);

    //         loader.dismiss();
    //       },
    //       (error) => {
    //         var response = JSON.parse(error._body);
    //         loader.dismiss();
    //         this.translateService.get(response.message).subscribe((value) => {
    //           this.services.presentToast(value);
    //         });
    //       }
    //     );
    // });
    loader.dismiss();
  }

  subPage(id) {
    this.navCtrl.push(PlazaStatSubPage, { id: id });
  }

  backPage() {
    this.navCtrl.pop();
  }
  openHeadPage() {
    this.navCtrl.push(ViewHeaderPage);
  }

  homePage() {
    this.navCtrl.setRoot(HomePage);
  }
}



// WEBPACK FOOTER //
// ./src/pages/plaza-stat-shopper/plaza-stat-shopper.ts